// extracted by mini-css-extract-plugin
export default {"melodyVideo":"fP-z","isFullWidth":"gP-z","landingPageVideo":"hP-z","play":"iP-z","iframeVideo":"jP-z","playHidden":"kP-z","fullwidth":"lP-z"};